import { render } from "./ChpPhysicianSearchWidgetResults.vue?vue&type=template&id=4f5b28f4"
import script from "./ChpPhysicianSearchWidgetResults.vue?vue&type=script&lang=js"
export * from "./ChpPhysicianSearchWidgetResults.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Website\\wwwroot\\FrontendCHP\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__